import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "uxp-for-newbies"
    }}>{`UXP for Newbies`}</h1>
    <p>{`If you've never written JavaScript, HTML, or CSS, but you want to develop plugins using UXP, you're in for a bit of a learning curve. It's not an impossible curve, not even a very steep one, and plenty of people have climbed it before you. So dive right in, and come back to these pages when you're ready.`}</p>
    <p>{`Just a couple of things before you start on your journey:`}</p>
    <p>{`You'll need to know a bit about your host application. In this case, you need to have a passing knowledge of Photoshop. Photoshop itself is a deep, broad program with a long history, but don't get sucked into trying to learn it all. Knowing something about Photoshop layers, selections, and basic tools (such as the pen and type tools) is a good start.`}</p>
    <p>{`Next, learn some basic JavaScript. Here, the Internet is not your friend. If you type "learn JavaScript" into Google, you get "About 2,040,000,000 results." `}<strong parentName="p">{`Two billion`}</strong>{` pages you could sift through. Maybe it's time to give this up and study something simpler, like quantum physics (only 123 million results for that search).`}</p>
    <p>{`Don't be discouraged. One popular starting point is the `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Learn/JavaScript"
      }}>{`Mozilla Developers Network tutorials`}</a>{`. But there are different learning styles: some like to read documentation, some prefer YouTube videos, and some like to just dive right in and make mistakes. Find the style that works for you.`}</p>
    <p>{`The same applies to learning HTML and CSS (Cascading Style Sheets), although both of those are arguably easier than JavaScript. Don't go too far learning any of these, as the HTML, CSS, and JavaScript you need to know to use UXP is much simpler than what's required for a typical website.`}</p>
    <p>{`An apocryphal quote from Picasso is "good artists borrow, great artists steal" -- which means that, when you get to the point where you're ready to try coding, looking at sample code and putting it in your own projects is usually just fine. Then go through the code at your leisure and make sure you understand what it's doing. And to start you off with some sample code, `}<a parentName="p" {...{
        "href": "../../../code_samples/"
      }}>{`look here`}</a>{`.`}</p>
    <p>{`Finally, `}<em parentName="p">{`ask questions`}</em>{`. There are many helpful people on the `}<a parentName="p" {...{
        "href": "https://forums.creativeclouddeveloper.com"
      }}>{`Adobe forums`}</a>{`, and chances are you'll find answers there.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      